import React from 'react';
import { useAuth } from '../authentication/AuthContext';
import { Link } from 'react-router-dom';
import '../index.css';
import '../styles/PricingPage.css';

export function SubscriptionStatus({ showDetailsLink = true }) {
  const { hasActiveSubscription, credits } = useAuth();

  if (!hasActiveSubscription) return null;

  return (
    <div className="subscription-status">
      <div className="subscription-badge">
        <span className="subscription-icon">★</span>
        <span>Premium Subscription</span>
      </div>
      <div className="subscription-details">
        <p>
          <strong>{credits}</strong> researches remaining this week
          {showDetailsLink && (
            <Link to="/account" className="subscription-link">View details</Link>
          )}
        </p>
      </div>
    </div>
  );
}

export function CreditsDisplay() {
  const { credits, isAdmin } = useAuth();

  if (isAdmin) {
    return (
        <p><strong>Admin Account:</strong> Unlimited Access</p>
    );
  }

  return (
    <div className="container">
      <p><strong>Remaining Credits:</strong> {credits} researches</p>
    </div>
  );
}

export default SubscriptionStatus;